<template>
    <footer id="footer" class="footer clearfix">
        <div class="ft-footer ft-footer clearfix">
            <div class=" fl">
                <div class="ft-icon">
                    <img src="../../static/img/bottom_logo.png"/>
                </div>
                <div class="ft-info">
                    <a class="ft-info-a" target="_blank" href="http://www.beian.miit.gov.cn">  豫ICP备16036132号-1</a>
                    <p>© COPYRIGHT 2021 DAYI ALL RIGHTS RESERVED</p>
                </div>
            </div>
            <!-- <div class="ft-more fr">
                <a href="/about.html#/introduction">联系天瑞</a>
                <el-divider direction="vertical"></el-divider>
                <a href="/work.html#/law">法律声明</a>
                <el-divider direction="vertical"></el-divider>
                <a href="/work.html#/children">集团子站</a>
                <el-divider direction="vertical"></el-divider>
                <a href="/work.html#/work">工作机会</a>
            </div> -->
        </div>
    </footer>
</template>

<script>
export default {
    name: 'pubheader',
    data () {
        return {
            event: null,
            userName: '',
            phone: '',
            visible: false
        }
    },
    mounted () {
    // this.getUserName()
    },
    methods: {

    }
}
</script>

<style>

.footer{
    /* height: 126px; */
    width: 100%;
    border-top: 1px solid rgba(0,0,0,0.10); 
    padding: 23px 0 23px;
}
.ft-footer{
    
    height: 54px;
}
.footer .ft-icon{
    margin-right: 20px;
}
.footer .ft-icon img{
    height: 50px;
}
.footer .ft-icon,.footer .ft-info{
    display: inline-block;
    color: #999;
     float: left;
}
.footer .ft-info{
    line-height:18px;
   margin-top: 9px;
}
.footer .ft-info-a{
    color: #999;
} 
.footer .ft-info p{
    font-size: 10px;
    -webkit-transform:scale(0.8);
     -webkit-transform-origin: left;
     font-family: 'Verdana';
}
.footer .ft-more{
    line-height: 54px;
}
.footer .ft-more a{
    color: #999999;
    margin: 0 11px 0 11px;
        font-family: "PingFangSC-Regular";
}
.footer .ft-more a:hover{
    color: #1641F0;
    
}
.el-pager li{
    font-size: 16px;
    font-weight: 600;
    width: 40px;
    height: 40px;
    line-height: 40px;
}
.el-pagination button {
      font-size: 16px;
    font-weight: 600;
     height: 40px;
    line-height: 40px;
}
el-pagination button, .el-pagination span:not([class*=suffix]) {
         font-size: 16px;
    font-weight: 600;
     height: 40px;
    line-height: 40px;
}
.el-pagination .btn-prev .el-icon {
    font-size: 16px;
    font-weight: 700;
}
.el-pagination .btn-next .el-icon {
    font-size: 16px;
    font-weight: 700;
}
.el-pager li.active {
    color: #409EFF;
    cursor: default;
background: rgba(0,0,0,0.05);
border-radius: 5px;
}
.el-pagination .el-input__inner{
font-size: 16px;
}
.el-pagination__editor.el-input .el-input__inner {
   height: 40px;
}
.ft-footer{
        /* background: #fff; */
    /* width: 100%; */
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    /* max-width: 1180px;
    min-width: 900px; */
    margin: 0 auto;
    margin-left: 80px;
}
</style>
